import { render, staticRenderFns } from "./CrmGroupCreate.vue?vue&type=template&id=5d95d3af&scoped=true&"
import script from "./CrmGroupCreate.vue?vue&type=script&lang=ts&"
export * from "./CrmGroupCreate.vue?vue&type=script&lang=ts&"
import style0 from "./CrmGroupCreate.vue?vue&type=style&index=0&id=5d95d3af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95d3af",
  null
  
)

export default component.exports